module.exports = __webpack_public_path__ + "087c87f84bc18055071f8efee2c33d5c.png";